import React, { useState } from "react"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"
import Email from "./email"

import { setShowSiteCredit } from "../../state/global"

import asterisk_filled from "../../images/icon/asterisk-desktop.svg"
import asterisk_hover from "../../images/icon/asterisk-black-desktop.svg"
import moment from "moment"

const Footer = ({ mobile, dispatch }) => {
  let [hover, setHover] = useState(false)
  let asterisk = hover ? asterisk_hover : asterisk_filled
  return (
    <Container fluid id="footer">
      <Row>
        <Col xs="12" md="8" className="email-container">
          <Email />
          {!mobile && (
            <p className="pt-4 text-grey">
              Copyright ©{moment().year()} reed art department. in memoriam: Michael Reed
            </p>
          )}
        </Col>
        <Col
          xs="10"
          md="2"
          className="d-flex flex-column justify-content-start social-container my-4 my-md-0"
        >
          <a href="mailto:careers@reedartdepartment.com">careers</a>
          <a
            href="https://www.instagram.com/reedartdepartment"
            target="_blank"
            rel="noreferrer noopener"
          >
            instagram
          </a>
          <a
            href="https://www.linkedin.com/company/reed-art-department/"
            target="_blank"
            rel="noreferrer noopener"
          >
            linkedin
          </a>
          {!mobile && (
            <div
              onClick={() => dispatch(setShowSiteCredit(true))}
              onKeyDown={() => dispatch(setShowSiteCredit(true))}
              role="button"
              tabIndex={0}
              className="site-credit text-grey mt-auto pb-3"
            >
              Site Credit
            </div>
          )}
        </Col>
        <Col
          xs="2"
          md="2"
          className="d-flex flex-column align-items-end  my-4 my-md-0"
        >
          <a
            href="https://jeffstaple.tv"
            target="_blank"
            rel="noreferrer noopener"
            onMouseOver={() => setHover(true)}
            onFocus={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            onBlur={() => setHover(false)}
          >
            <img src={asterisk} alt="" width="25" />
          </a>
        </Col>
      </Row>
      {mobile && (
        <Row>
          <Col className="w-100 d-flex justify-content-between">
            <div
              onClick={() => dispatch(setShowSiteCredit(true))}
              onKeyDown={() => dispatch(setShowSiteCredit(true))}
              role="button"
              tabIndex={0}
              className="site-credit text-grey mt-auto pb-3"
            >
              Site
              <br />
              Credit
            </div>
            <p className="pt-4 text-grey text-right">
              Copyright ©2020
              <br />
              reed art department.
              <br />
              in memoriam: Michael Reed
            </p>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default connect(state => ({ mobile: state.global.mobile }), null)(Footer)
